import styled from "styled-components";

export const Wrapper = styled.div`
width: 100%;
height: 100%;
padding-right: 20px;
margin-top: 20px;
`
export const SearchWrapper = styled.div`
margin-left: 20px;
`
export const ButtonsWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
padding-right: 20px;
`
export const Content = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
padding-top: 20px;
`
export const ContentDialogWrapper = styled.div`
width: 100%;
height: 100%;
min-height: 0;
display: flex;
flex-direction: column;
overflow: hidden;
position: relative;
p{
    color: #ffffff !important;
    opacity: 1;
    display: flex;
    justify-content: center;
}
`
export const DescriptionColumn = styled.div`
width:28rem;
overflow: hidden;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
`
